import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import { t } from 'ttag';

export const MAX_NAME_LENGTH = 60;

type GroupNameFormProps = {
    id: string;
    onSubmit: (name: string) => void;
    label?: string;
    help?: string;
    busy?: boolean;
    // the buttons that go with it
    children: (submit: () => void, valid: boolean) => React.ReactNode;
};

// The name everyone gives on joining or starting a group order: it shows what they've added
const GroupNameForm = ({ id, onSubmit, label, help, busy, children }: GroupNameFormProps) => {
    const [name, setName] = useState('');
    const [touched, setTouched] = useState(false);

    const valid = name.trim().length > 0;

    const submit = () => {
        setTouched(true);

        if (valid && !busy) onSubmit(name.trim());
    };

    return (
        <>
            <Form
                onSubmit={(e: React.FormEvent) => {
                    e.preventDefault();
                    submit();
                }}
            >
                <Form.Group controlId={id} className="mb-0">
                    <Form.Label>{label ?? t`What is your name?`}</Form.Label>
                    <Form.Control
                        type="text"
                        autoComplete="given-name"
                        maxLength={MAX_NAME_LENGTH}
                        placeholder={t`E.g. Joe S`}
                        value={name}
                        isInvalid={touched && !valid}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">{t`Please enter your name`}</Form.Control.Feedback>
                    <Help>{help ?? t`We use this to show what items you've ordered`}</Help>
                </Form.Group>
            </Form>
            <Buttons>{children(submit, valid)}</Buttons>
        </>
    );
};

const Help = styled.p`
    margin: 8px 0 0;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-grey);
`;

const Buttons = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 24px;
`;

export default GroupNameForm;
